import React, {useRef, useState, useEffect, useContext, useMemo } from "react";
import { Stepper } from "@activehub/common-components-spa-resource";
import "./AccessCodeRegister.scss";
import AccessCode from "./AccessCode";
import AccessCodeUserDetails from './AccessCodeUserDetails';
import { useAction } from './useAction';
import AccessCodeRegistrationComplete from "./AccessCodeRegistrationComplete"

const steps = [
  'Access code', 
  'Your details', 
  'Registration complete'
]

const AccessCodeForm = (props) => {
    let svgPath = `/images/login-stepper-success.svg`;
    const { step, accessCode, ebookTitle,handleNextStep, handleBackStep } = useAction();
    const renderstep = (step) => {
      switch (step) {    
        case 1: return <AccessCode onNextStep={handleNextStep} onBackStep={handleBackStep} accessCode={accessCode} ebookTitle = {ebookTitle}/>;
        case 2: return <AccessCodeUserDetails onNextStep={handleNextStep} onBackStep={handleBackStep} accessCode={accessCode} ebookTitle = {ebookTitle}/>;
        case 3: return <AccessCodeRegistrationComplete onNextStep={handleNextStep} onBackStep={handleBackStep}/>;
        default: return <div>404 - Not Found</div>
      }
    }

    return (
      <div className="ActiveHubForm" >
          <Stepper steps={steps} active={step === 3 ? 4 : step} themeClass={"pearsonRoyalBlueV1"} svgPath={svgPath} />
          { renderstep(step) }
      </div>
    )
};

export default AccessCodeForm;
